import { inject, provide, reactive } from "@vue/composition-api";
import { getId, isAuthenticated, onLogOut } from "@/functions/authentication-functions";
import axios from "axios";
import { SettingsContext } from "@/utilities/settings-context";

export interface UserState {
    admin: { [key: number]: boolean };
    isInternalSales: { [key: number]: boolean };
}

const stateSymbol = Symbol('user-state');
const createState = () => {
    return reactive<UserState>({
        admin: {},
        isInternalSales: {}
    });
};

export function useUserState() {
    return inject(stateSymbol) as UserState;
}

export function provideUserState() {
    return provide(
        stateSymbol,
        createState()
    );
}

export async function populateUserState() {
    const state = useUserState();
    onLogOut(() => {
        state.admin = {};
        state.isInternalSales = {}
    });
}
